// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rs-c";
export var backButton = "_rs-4";
export var backIcon = "_rs-5";
export var chevronShortcut = "_rs-6";
export var container = "_rs-1";
export var editor = "_rs-8";
export var editorWrapper = "_rs-7";
export var prefix = "_rs-2";
export var searchIcon = "_rs-3";
export var suffix = "_rs-9";
export var suffixContent = "_rs-a";
export var suffixText = "_rs-b";
export var wrapper = "_rs-0";